import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiClientService } from '../../../core/http/api-client.service';
import {
  AcceptRescheduleProposalResponse,
  RejectRescheduleProposalRequest,
  RejectRescheduleProposalResponse,
  RescheduleProposalFilters,
  RescheduleProposalItem,
  RescheduleProposalItemDto,
  RescheduleProposalPage,
  RescheduleProposalPageDto,
  RescheduleProposalSort
} from './reschedule-proposals.models';
import { mapRescheduleProposalItem } from './reschedule-proposals.mapper';

@Injectable({
  providedIn: 'root'
})
export class RescheduleProposalsService
{
  private readonly apiClient = inject(ApiClientService);

  public getPage(
    params: {
      limit: number;
      cursor?: string | null;
      companyId?: string;
      filters?: RescheduleProposalFilters;
      sort?: RescheduleProposalSort;
      pendingFirst?: boolean;
    },
  ): Observable<RescheduleProposalPage>
  {
    const query = {
      companyId: params.companyId,
      appointmentId: params.filters?.appointmentId,
      clinicId: params.filters?.clinicId,
      clientId: params.filters?.clientId,
      procedureTypeId: params.filters?.procedureTypeId,
      deviceId: params.filters?.deviceId,
      specialistUserId: params.filters?.specialistUserId,
      reason: params.filters?.reason?.trim() || undefined,
      status: params.filters?.status,
      sort: params.sort,
      pendingFirst: params.pendingFirst,
      limit: params.limit,
      cursor: params.cursor ?? undefined,
    };

    return this.apiClient.get<RescheduleProposalPageDto>(
      '/reschedule-proposals',
      query
    ).pipe(
      map((page: RescheduleProposalPageDto | null) => ({
        items: Array.isArray(page?.items) ? page.items.map(mapRescheduleProposalItem) : [],
        nextCursor: page?.nextCursor ?? null,
        hasMore: !!page?.hasMore,
      })),
    );
  }

  public getById(
    id: string
  ): Observable<RescheduleProposalItem>
  {
    return this.apiClient.get<RescheduleProposalItemDto>(
      `/reschedule-proposals/${id}`
    ).pipe(
      map(mapRescheduleProposalItem)
    );
  }

  public accept(
    id: string
  ): Observable<AcceptRescheduleProposalResponse>
  {
    return this.apiClient.patch<AcceptRescheduleProposalResponse, undefined>(
      `/reschedule-proposals/${id}/accept`,
      undefined
    );
  }

  public reject(
    id: string,
    payload?: RejectRescheduleProposalRequest
  ): Observable<RejectRescheduleProposalResponse>
  {
    return this.apiClient.patch<RejectRescheduleProposalResponse, RejectRescheduleProposalRequest | undefined>(
      `/reschedule-proposals/${id}/reject`,
      payload
    );
  }
}
